import * as React from 'react'
import { Link, Route } from 'react-router-dom'
import { RouteComponentProps } from 'react-router'
import UserTopPanel from '../../../containers/trips/UserTopPanel'
import {
  activeTripStatuses,
  allowNoShowButtonStatuses,
  cancelledTripsStatusesDashboard,
  onDemandNoDriver,
  scheduledTripStatuses,
  TripStatuses,
  tripIndicatorReloadStatuses,
  enRouteTripStatuses,
  waitingForPickupTripStatuses
} from '../../../constants/trip-statuses'
import {
  IActiveTripResponseV2,
  ICoordinates,
  ITripFilters,
  IOrgCreateObj,
  IServiceListFilterDTO,
  IRiderObject,
  IZoneObject
} from '../../../types'
import UIMessages from '../../../utils/ui-messages'
import TripDetailLocation from '../../../containers/trips/location'
import StatusTrip from './StatusTrip'
import TripCompleted from './TripCompleted'
import TripScheduled from './TripScheduled'
import TripBookingFailed from './TripBookingFailed'
import TripIntegrationFailed from './TripIntegrationFailed'
import TripEnRoute from './TripEnRoute'
import TripRequested from './TripRequested'
import TripWaitingForPickup from './TripWaitingForPickup'
import ManualTripCompleteModal from '../../../containers/trips/ManualTripCompleteModal'
import ManualTripCancelModal from '../../../containers/trips/ManualTripCancelModal'
import ManualTripNoShowModal from '../../../containers/trips/ManualTripNoShowModal'
import CancelBillableModal from '../../../containers/trips/CancelBillableModal'
import { mapViewStrategyStages } from '../../MapView'
import AssignOperatorModal from '../../../containers/trips/management/AssignOperatorModal'
import TripActivityLog from '../../../containers/trips/TripActivityLog'
import PastTripsLogs from '../../../containers/trips/PastTripsLogs'
import ReactTooltip from 'react-tooltip'
import ArrowDown from '../../icons/ui/ArrowDown'
import Menu, { SubMenu, Item as MenuItem } from 'rc-menu'
import moment from 'moment'
import history from '../../../history'
import Copy from 'src/components/icons/ui/Copy'
import Calenedar from 'src/components/icons/ui/Calendar'
import Audit from './Audit'
import { tripRequestRidersHelper } from 'src/utils/group-rider'
import SubStatusTrip from './SubStatusTrip'

export interface ITripDetailPaneProps extends RouteComponentProps {
  orgId: string
  currentTripId: string
  currentTrip: IActiveTripResponseV2
  pastTrips: IActiveTripResponseV2[]
  organizations: IOrgCreateObj | null
  requestedNumber: string | null
  auditTrail: Array<{
    id: string
    createdAt: string
    updatedBy: string
    prevData: string
    currentData: string
    column: number
  }>
  showDriversPane: boolean
  riders: { [key: number]: IRiderObject }
  serviceId: string
  tripFilters: ITripFilters
  zones: { [key: string]: IZoneObject }
  cancelTrip: (tripId: string, comment: string) => Promise<any>
  getTripById: (tripId: string) => Promise<any>
  getManyTrips: (params: ITripFilters) => Promise<any>
  setCurrentTrip: (tripId: string) => void
  getNearbyDrivers: (location: ICoordinates) => Promise<any>
  setCurrentTripStage: (stage: string) => Promise<any>
  clearMap: () => void
  cloneTrip: (trip: IActiveTripResponseV2, useTripNotes?: boolean) => Promise<any>
  getUberOperatorDriver: (tripId: string, orgID: string) => void
  hideMembers: () => void
  showMembers: () => void
  fetchTotalTripsPerService: (orgId: string, dto: IServiceListFilterDTO) => Promise<any[]>
  fetchRiders: () => Promise<any>
  getGoinzones: (orgId: string, serviceId: string) => Promise<any>
}
interface ITripPaneState {
  fetchOtherTrip: boolean
  requestedNumber: string | null
  viewRiders: boolean
}
function handleClick(info: any) {
  console.log(`clicked ${info.key}`)
  console.log(info)
}

const uberItegrationIds = ['11025f44-1c4a-49b5-9adb-d3d6bd5dd5b6', '6a8e56b8-914e-4b48-a387-e6ad21d9c00c']

const MenuTitle = () => {
  return (
    <div className='' style={{ maxWidth: '100', overflow: 'hidden' }}>
      <span className='p0 m0 font-small f-color-878686'>More Details</span>
      <ArrowDown className='ml-half icon--13x13' />
    </div>
  )
}

const PastTrips = () => {
  return (
    // <div className='flex items-center cursor--pointer'>
    <div className='' style={{ maxWidth: '100', overflow: 'hidden' }}>
      <span className='p0 m0 font-small f-color-878686'>Past Trips</span>
      <ArrowDown className='ml-half icon--13x13' />
    </div>
  )
}

const History = () => {
  return (
    // <div className='flex items-center cursor--pointer'>
    <div className='' style={{ maxWidth: '100', overflow: 'hidden' }}>
      <span className='p0 m0 font-small f-color-878686'>Audit Trail</span>
      <ArrowDown className='ml-half icon--13x13' />
    </div>

    // </div>
  )
}

let copyingTrip = false
class TripDetailPane extends React.Component<ITripDetailPaneProps, ITripPaneState> {
  private newTripStatusIds = '1, 10, 19, 21, 25, 27, 29' // REQUESTED, CANCELLED, NO_RESPONSE_OPERATOR, SCHEDULE_REQUESTED, WAITING, DISPATCH_ASSIGNED_DRIVER, PENDING
  private statusStrategy = [
    {
      status: UIMessages.trip.statuses.scheduleRequested,
      filter: (status: string) => status === TripStatuses.SCHEDULE_REQUESTED,
      render: () => (
        <TripScheduled
          createTrip={this.createTrip}
          cloneTrip={this.props.cloneTrip}
          cancelTrip={this.cancelTrip}
          getTripById={this.props.getTripById}
          currentTrip={this.props.currentTrip}
          setCurrentTripStage={this.props.setCurrentTripStage}
        />
      )
    },
    {
      status: UIMessages.trip.statuses.scheduled,
      filter: (status: string) => status === TripStatuses.SCHEDULED,
      render: () => (
        <TripScheduled
          createTrip={this.createTrip}
          cloneTrip={this.props.cloneTrip}
          cancelTrip={this.cancelTrip}
          getTripById={this.props.getTripById}
          currentTrip={this.props.currentTrip}
          setCurrentTripStage={this.props.setCurrentTripStage}
        />
      )
    },
    {
      status: UIMessages.trip.statuses.willCallLater,
      filter: (status: string) => status === TripStatuses.WILL_CALL,
      render: () => (
        <TripScheduled
          createTrip={this.createTrip}
          cloneTrip={this.props.cloneTrip}
          cancelTrip={this.cancelTrip}
          getTripById={this.props.getTripById}
          currentTrip={this.props.currentTrip}
          setCurrentTripStage={this.props.setCurrentTripStage}
        />
      )
    },
    {
      status: UIMessages.trip.statuses.waitingForAccept,
      filter: (status: string) => status === TripStatuses.REQUESTED || status === TripStatuses.DISPATCH_ASSIGNED_DRIVER,
      render: () => <TripRequested getTripById={this.props.getTripById} currentTrip={this.props.currentTrip} />
    },
    {
      status: 'All drivers are busy',
      filter: (status: string) => status === TripStatuses.WAITING,
      render: () => <TripRequested getTripById={this.props.getTripById} currentTrip={this.props.currentTrip} />
    },
    {
      filter: (status: string) =>
        status === TripStatuses.CANCELLED ||
        status === TripStatuses.DRIVER_CANCELLED ||
        status === TripStatuses.RIDER_CANCELLED ||
        status === TripStatuses.CANCEL_BILLABLE ||
        status === TripStatuses.NO_SHOW_RIDER ||
        status === TripStatuses.COMPLETED ||
        status === TripStatuses.MANUALLY_COMPLETED ||
        status === TripStatuses.COMPLETED_PENDING_PAYMENT ||
        status === TripStatuses.REJECTED ||
        status === TripStatuses.NO_RESPONSE_OPERATOR,
      render: () => (
        <TripCompleted
          currentTrip={this.props.currentTrip}
          uberItegrationIds={uberItegrationIds}
          setCurrentTripStage={this.props.setCurrentTripStage}
        />
      )
    },
    {
      filter: (status: string) => status === TripStatuses.BOOKING_FAILED || status === TripStatuses.EXPIRED,
      render: () => (
        <TripBookingFailed currentTrip={this.props.currentTrip} setCurrentTripStage={this.props.setCurrentTripStage} />
      )
    },
    {
      filter: (status: string) => status === TripStatuses.INTEGRATION_FAILED,
      render: () => (
        <TripIntegrationFailed
          currentTrip={this.props.currentTrip}
          setCurrentTripStage={this.props.setCurrentTripStage}
        />
      )
    },
    {
      filter: (status: string) =>
        status === TripStatuses.ACCEPTED || status === TripStatuses.TO_PICK_UP || status === TripStatuses.AT_PICK_UP,
      render: () => (
        <TripWaitingForPickup
          getTripById={this.props.getTripById}
          currentTrip={this.props.currentTrip}
          setCurrentTripStage={this.props.setCurrentTripStage}
        />
      )
    },
    {
      filter: (status: string) =>
        status === TripStatuses.PICKED_UP || status === TripStatuses.AT_DROP_OFF || status === TripStatuses.TO_DROP_OFF,
      render: () => (
        <TripEnRoute
          getTripById={this.props.getTripById}
          currentTrip={this.props.currentTrip}
          setCurrentTripStage={this.props.setCurrentTripStage}
        />
      )
    },
    {
      status: UIMessages.trip.statuses.pending,
      filter: (status: string) => status === TripStatuses.PENDING,
      render: () => <TripRequested getTripById={this.props.getTripById} currentTrip={this.props.currentTrip} />
    }
  ]

  constructor(props: ITripDetailPaneProps) {
    super(props)
    this.state = {
      fetchOtherTrip: true,
      requestedNumber: null,
      viewRiders: false
    }
  }

  public componentWillMount() {
    this.props.setCurrentTrip(this.props.currentTripId)
    this.props.getTripById(this.props.currentTripId)
    this.props.setCurrentTripStage(mapViewStrategyStages.showNearbyDrivers)
    this.setState({ fetchOtherTrip: true })
    if (this.props.orgId) {
      this.displayTotalTripsPerService(this.props.orgId, this.newTripStatusIds)
    }
  }

  public componentDidMount() {
    this.props.fetchRiders()
  }

  public componentDidUpdate(prevProps: ITripDetailPaneProps) {
    if (prevProps.currentTripId !== this.props.currentTripId) {
      this.props.setCurrentTrip(this.props.currentTripId)
      this.props.getTripById(this.props.currentTripId)
      this.setState({ fetchOtherTrip: true })
    }
    const activeStatus = waitingForPickupTripStatuses.concat(enRouteTripStatuses)

    if (
      this.props.currentTrip &&
      this.props.currentTrip.organizationId &&
      this.state.fetchOtherTrip &&
      !activeStatus.includes(this.props.currentTrip.lastStatus)
    ) {
      const before = moment(this.props.currentTrip.createdAt)
        .subtract(1, 'month')
        .format('YYYY-MM-DD')
      const after = moment(this.props.currentTrip.createdAt).format('YYYY-MM-DD')
      this.props.getManyTrips({
        orgId: this.props.currentTrip.organizationId,
        riderId: [this.props.currentTrip.rider.riderId],
        timeStart: before + 'T00:00:00',
        timeEnd: after + 'T23:59:00',
        timeField: 'tripCreated',
        sortBy: ['created-desc'],
        skip: 0,
        take: 10
      })
      this.setState({
        fetchOtherTrip: false
      })
      // this.setState({tripRidersHelper: tripRequestRidersHelper({tripRequestRiders: this.props.currentTrip.tripsGroupRides})})
    }

    if (prevProps.requestedNumber !== this.props.requestedNumber) {
      this.setState({
        requestedNumber: this.props.requestedNumber
      })
    }
    //if trip is active do not show live dirvers pane
    if (
      this.props.currentTrip &&
      this.props.currentTrip.lastStatus &&
      activeTripStatuses.includes(this.props.currentTrip.lastStatus)
    ) {
      this.props.hideMembers()
    }

    // check if the prev and current status aren't the same and allows reloading of status
    if (
      this.props.orgId &&
      prevProps.currentTripId === this.props.currentTripId &&
      (prevProps.currentTrip && prevProps.currentTrip.lastStatus) !==
        (this.props.currentTrip && this.props.currentTrip.lastStatus) &&
      (this.props.currentTrip && tripIndicatorReloadStatuses.includes(this.props.currentTrip.lastStatus))
    ) {
      this.displayTotalTripsPerService(this.props.orgId, this.newTripStatusIds)
    }
  }

  public componentWillUnmount() {
    // added if statement to prevent clearing map details when user is copying a trip
    if (!copyingTrip) {
      this.props.clearMap() // might cause issues with map centering. modify clear map  as needed
    }
    this.props.setCurrentTrip('')
    if (this.props.showDriversPane === true) {
      this.props.showMembers() // reset to show live drives pane
    }

    // add slight delay to give time whenever invoking updating trip status API
    setTimeout(() => this.displayTotalTripsPerService(this.props.orgId, this.newTripStatusIds), 2000)
    copyingTrip = false
  }

  public render() {
    const { currentTrip, organizations, riders } = this.props
    const Riders = Object.values(riders)

    if (!currentTrip) {
      return (
        <div className='p1 bg#333'>
          <p>{UIMessages.trip.noTrip}</p>
        </div>
      )
    }
    const tripRidersHelper = tripRequestRidersHelper({ tripRequestRiders: currentTrip.tripsGroupRides || [] })
    const timeFormat = this.props.organizations ? this.props.organizations.timeFormat : 'mil'
    const currentTripStatus = currentTrip.lastStatus
      ? {
          status: currentTrip.lastStatus,
          createdAt: currentTrip.lastStatusAt
        }
      : currentTrip.status
      ? currentTrip.status[currentTrip.status.length - 1]
      : {
          status: '',
          createdAt: ''
        }
    const statusStrategyItem = this.statusStrategy.find(it => it.filter(currentTripStatus.status))
    const activeTrip = activeTripStatuses.concat(scheduledTripStatuses).includes(currentTrip.lastStatus)
    const isUber = uberItegrationIds.includes(
      currentTrip.product.integrationId ? currentTrip.product.integrationId : ''
    )
    const hoverMessage =
      organizations && organizations.name && organizations.callerID
        ? ` Press to request new driver number using ${organizations.name} caller ID ${organizations.callerID}`
        : 'no number avaialble'
    const callMessage =
      organizations && organizations.name && organizations.callerID
        ? `To call the driver dial: ${this.state.requestedNumber} from ${organizations.name} caller ID ${
            organizations.callerID
          }`
        : 'no number avaialble'

    const matchingRider = Riders.find(rider => {
      return rider.id === currentTrip.rider.riderId
    })

    return (
      <React.Fragment>
        <Route path={`${this.props.match.path}/complete-manually`} component={ManualTripCompleteModal} />
        <Route path={`${this.props.match.path}/cancel-manually`} component={ManualTripCancelModal} />
        <Route path={`${this.props.match.path}/cancel-billable`} component={CancelBillableModal} />
        <Route path={`${this.props.match.path}/noshow-manually`} component={ManualTripNoShowModal} />
        <Route path={`${this.props.match.path}/assign-operator`} exact={true} component={AssignOperatorModal} />
        <div className='p1 bg#333'>
          <UserTopPanel riderId={currentTrip.rider.riderId} />
          <div className='flex'>
            <div className='flex-auto'>
              <StatusTrip
                currentTrip={this.props.currentTrip}
                displayText={statusStrategyItem && statusStrategyItem.status}
                status={currentTripStatus}
              />
            </div>
          </div>
          {(currentTripStatus.status === TripStatuses.TO_PICK_UP ||
            currentTripStatus.status === TripStatuses.AT_PICK_UP ||
            currentTripStatus.status === TripStatuses.PICKED_UP ||
            currentTripStatus.status === TripStatuses.TO_DROP_OFF) &&
            (currentTrip.lastSubStatus !== null && currentTrip.lastSubStatus !== undefined) && (
              <div className='flex'>
                <div className='flex-auto'>
                  <SubStatusTrip displayText={currentTrip.lastSubStatus} />
                </div>
              </div>
            )}
          {/* display only if integration id is uber */}
          {isUber === true && activeTrip === true && (
            <div title={hoverMessage} className='ml1 cursor--pointer'>
              <button
                className='SubmitButton btn bg-green rounded font-white weight-300'
                onClick={() => {
                  if (this.props.currentTrip.organizationId) {
                    this.props.getUberOperatorDriver(this.props.currentTripId, this.props.currentTrip.organizationId)
                  }
                }}
              >
                Call Driver
              </button>
            </div>
          )}
          {this.state.requestedNumber && activeTrip && <div>{callMessage}</div>}

          {statusStrategyItem && statusStrategyItem.render()}
          <TripDetailLocation iTripStatus={currentTrip.lastStatus} riderTrip={currentTrip} />
          {(!matchingRider || (matchingRider && matchingRider.isArchived === undefined)) && (
            <div className='flex items-baseline'>
              <div title='Press to request again' className='ml1 cursor--pointer'>
                <Copy
                  onClick={() => {
                    copyingTrip = true
                    this.cloneTrip(currentTrip)
                  }}
                />
              </div>
              <div title='See planned trips' className='ml1 cursor--pointer icon--12x12'>
                <Link
                  to={`/riders/${this.props.currentTrip.rider.riderId}/profile/recurringTrips`}
                  className='MenuItem flex cursor--pointer'
                >
                  <Calenedar />
                </Link>
              </div>
            </div>
          )}
          {this.manualComplete(currentTripStatus.status, matchingRider ? matchingRider.isArchived : false)}
          <Menu onClick={handleClick} mode='horizontal' openAnimation='slide-down' triggerSubMenuAction='click'>
            <SubMenu title={<MenuTitle />} popupOffset={[10, 0]} overflowedIndicator={false} key='1'>
              <MenuItem key='1-1' className='td-activity-log-container'>
                <TripActivityLog currentTrip={this.props.currentTrip} timeFormat={timeFormat} />
              </MenuItem>
            </SubMenu>
            <SubMenu title={<PastTrips />} popupOffset={[10, 0]} overflowedIndicator={false} key='2'>
              <MenuItem key='1-2' className='ptl-menu-item'>
                <PastTripsLogs pastTrips={this.props.pastTrips} />
              </MenuItem>
            </SubMenu>
            <SubMenu title={<History />} popupOffset={[10, 0]} overflowedIndicator={false} key='3'>
              <MenuItem key='1-3'>
                <Audit auditTrail={this.props.auditTrail} timeFormat={timeFormat} />
              </MenuItem>
            </SubMenu>
          </Menu>
          {currentTrip.details && (
            <div className='mt1'>
              <label className='font-black'>Extra Details</label>
              {currentTrip.details.authCode && (
                <div>
                  <label className='h5'>Auth Code</label>
                  <span className='bold font-black h6 ml3'>{currentTrip.details.authCode}</span>
                </div>
              )}
              {currentTrip.details.billingCode && (
                <div>
                  <label className='h5'>Billing Code</label>
                  <span className='bold font-black h6 ml3'>{currentTrip.details.billingCode}</span>
                </div>
              )}
            </div>
          )}
        </div>
      </React.Fragment>
    )
  }
  public cloneTrip(trip: IActiveTripResponseV2) {
    history.push(`/trips/create/${trip.rider.riderId}`)
    this.props.cloneTrip(this.props.currentTrip)
  }
  public createTrip(riderId: string) {
    history.push(`/trips/create/${riderId}`)
  }
  public cancelTrip = () => {
    this.props.cancelTrip(this.props.currentTripId, 'making new trip')
  }
  private toggleViewRiders = () => {
    this.setState(state => {
      const newState = { ...state }
      newState.viewRiders = !state.viewRiders
      return newState
    })
  }
  private displayTotalTripsPerService = (orgId: string, filterStatusIds: string) => {
    // Get the total trips from 1 hour ago up to the current time plus 2 hours (REQUESTED, SCHEDULE_REQUEST last trip status)
    const { timeStart, timeEnd } = this.props.tripFilters
    const from = timeStart ? moment(timeStart) : moment()
    const to = timeEnd ? moment(timeEnd) : moment()
    this.props.fetchTotalTripsPerService(orgId, {
      fromDate: from
        // .subtract(1, 'hours')
        .startOf('day')
        .toISOString(),
      toDate: to
        // .add(2, 'hours')
        .startOf('day')
        .endOf('day')
        .toISOString(),
      lastStatusIds: filterStatusIds
    })
  }
  private copyAndCancel = () => {
    history.push(`/trips/create/${this.props.currentTrip.rider.riderId}`)
    this.props.cloneTrip(this.props.currentTrip, true)
    this.cancelTrip()
    this.createTrip(this.props.currentTrip.rider.riderId)
  }
  private manualComplete = (status: string, isArchived: boolean) => {
    if (
      status !== TripStatuses.NO_SHOW_RIDER &&
      status !== TripStatuses.COMPLETED &&
      status !== TripStatuses.CANCEL_BILLABLE &&
      status !== TripStatuses.RIDER_CANCELLED &&
      status !== TripStatuses.MANUALLY_COMPLETED
    ) {
      const showNoShowRider = allowNoShowButtonStatuses.includes(status)
      const isCancelled = cancelledTripsStatusesDashboard.includes(status)
      const requqested = onDemandNoDriver.includes(status)
      return (
        <div className='mt2'>
          <ReactTooltip
            id='change status'
            aria-haspopup='true'
            globalEventOff='click'
            effect='solid'
            place='top'
            className='shadow'
            delayHide={200}
            delayUpdate={200}
            backgroundColor='#fff'
          >
            <div className='ListItemMenu flex-auto' style={{ width: '300px' }}>
              {!isCancelled && !isArchived && (
                <div
                  onClick={() => {
                    copyingTrip = true
                    this.copyAndCancel()
                  }}
                  className='col-12 center pt1 bt1 bl1 br1 rounded bold cursor--pointer'
                >
                  <span className='font-dark-grey'>{UIMessages.trip.copyAndCancel}</span>
                </div>
              )}
              {!isCancelled && requqested && (
                <Link
                  to={`/trips/${this.props.currentTrip.id}/assign-operator`}
                  className='MenuItem flex cursor--pointer'
                >
                  <div className='col-12 center pt1 bt1 bl1 br1 rounded bold cursor--pointer'>
                    <span className='font-dark-grey'>{UIMessages.trip.copyAndAssign}</span>
                  </div>
                </Link>
              )}
              <Link to={`${this.props.match.url}/complete-manually`} className='MenuItem flex cursor--pointer'>
                <div className='col-12 center pt1 bt1 bl1 br1 rounded bold cursor--pointer'>
                  <span className='font-dark-grey'>{UIMessages.manualTripComplete.menuItemLabel}</span>
                </div>
              </Link>
              <Link to={`${this.props.match.url}/cancel-manually`} className='MenuItem flex cursor--pointer'>
                <div className='col-12 center pt1 bt1 bl1 br1 rounded bold cursor--pointer'>
                  <span className='font-dark-grey'>{UIMessages.manualTripCancel.menuItemLabel}</span>
                </div>
              </Link>
              <Link to={`${this.props.match.url}/cancel-billable`} className='MenuItem flex cursor--pointer'>
                <div className='col-12 center pt1 bt1 bl1 br1 rounded bold cursor--pointer'>
                  <span className='font-dark-grey'>{UIMessages.trip.statuses.cancelBillable}</span>
                </div>
              </Link>
              {showNoShowRider && (
                <Link to={`${this.props.match.url}/noshow-manually`} className='MenuItem flex cursor--pointer'>
                  <div className='col-12 center pt1 pb1 bt1 bl1 br1 rounded bold cursor--pointer'>
                    <span className='font-dark-grey'>{UIMessages.manualTripNoShow.menuItemLabel}</span>
                  </div>
                </Link>
              )}
            </div>
          </ReactTooltip>
          <div className='flex'>
            <div
              className='col-12 center py1 bg-light-orange font-white rounded bold cursor--pointer'
              data-tip='change status'
              data-for='change status'
            >
              {UIMessages.trip.changeStatus}
            </div>
          </div>
        </div>
      )
    }
    return <React.Fragment />
  }
}

export default TripDetailPane



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/TripDetailPane.tsx